import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaCog } from 'react-icons/fa';
import ChangePasswordModal from './ChangePasswordModal';
import { getUserRoles } from '../auth/cookieUtils';
import './Sidebar.css';

const Sidebar = () => {
  const roles = getUserRoles();
  const isAdmin = roles.includes('ADMIN') || roles.includes('SUPER_ADMIN');
  const [equipmentOpen, setEquipmentOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
const [showChangePassword, setShowChangePassword] = useState(false);
  const [boilerModuleEnabled, setBoilerModuleEnabled] = useState(
    () => sessionStorage.getItem('selectedLocationBoilerModuleEnabled') === 'true'
  );

  useEffect(() => {
    const handleLocationContextChanged = (event) => {
      if (typeof event.detail?.boilerModuleEnabled === 'boolean') {
        setBoilerModuleEnabled(event.detail.boilerModuleEnabled);
        return;
      }

      setBoilerModuleEnabled(
        sessionStorage.getItem('selectedLocationBoilerModuleEnabled') === 'true'
      );
    };

    window.addEventListener('odin:location-context-changed', handleLocationContextChanged);
    return () => {
      window.removeEventListener('odin:location-context-changed', handleLocationContextChanged);
    };
  }, []);


  return (
    <div className="dashboard-sidebar">
      <ul>
        <NavLink
          to="/dashboard"
          className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
        >
          Dashboard
        </NavLink>
       <li
          className="sidebar-link equipment-toggle"
          onClick={() => setEquipmentOpen(!equipmentOpen)}
          style={{ cursor: 'pointer' }}
        >
          Equipment {equipmentOpen ? '▾' : '▸'}
        </li>

        {equipmentOpen && (
          <div className="equipment-submenu">
            <NavLink
              to="/assets_database"
              className={({ isActive }) =>
                isActive
                  ? 'sidebar-link sidebar-sub-link active'
                  : 'sidebar-link sidebar-sub-link'
              }
            >
              Assets Database
            </NavLink>

            <NavLink
              to="/valves"
              className={({ isActive }) =>
                isActive
                  ? 'sidebar-link sidebar-sub-link active'
                  : 'sidebar-link sidebar-sub-link'
              }
            >
              Valves
            </NavLink>

            {boilerModuleEnabled && (
              <NavLink
                to="/boiler-matrices"
                className={({ isActive }) =>
                  isActive
                    ? 'sidebar-link sidebar-sub-link active'
                    : 'sidebar-link sidebar-sub-link'
                }
              >
                Boiler Matrices
              </NavLink>
            )}
          </div>
        )}


        <NavLink
          to="/site-files"
          className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
        >
          Site Files
        </NavLink>
        <NavLink
          to="/inspection_scheduling"
          className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
        >
          Inspection Scheduling
        </NavLink>
        <NavLink
          to="/action-items"
          className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
        >
          Action Items
        </NavLink>

        {isAdmin && (
          <>
            <li
              className="sidebar-link admin-toggle"
              onClick={() => setAdminOpen(!adminOpen)}
              style={{ cursor: 'pointer' }}
            >
              Administration {adminOpen ? '▾' : '▸'}
            </li>
            {adminOpen && (
              <div className="admin-submenu">
                <NavLink
                  to="/administration/userManagement"
                  className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
                >
                  User Management
                </NavLink>
                <NavLink
                  to="/administration/companyManagement"
                  className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
                >
                  Company Management
                </NavLink>
                <NavLink
                  to="/administration/equipmentManagement"
                  className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
                >
                  Equipment Management
                </NavLink>
              </div>
            )}
          </>
        )}
        {/* Gear Button + Dropdown */}
        <li style={{ marginTop: '20px', cursor: 'pointer' }} onClick={() => setSettingsOpen(!settingsOpen)}>
          <FaCog /> {settingsOpen ? '▾' : '▸'}
        </li>
        {settingsOpen && (
          <ul className="admin-submenu">
            <li className="sidebar-link" onClick={() => setShowChangePassword(true)}>Change Password</li>
          </ul>
        )}
      </ul>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  );
};

export default Sidebar;
